/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const DesktopXXLBreakpointIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="DesktopXXLBreakpointIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 11H2C1.44772 11 1 10.5523 1 10V2C1 1.44772 1.44772 1 2 1H15C15.5523 1 16 1.44772 16 2V10C16 10.5523 15.5523 11 15 11H12V13H14V14H3V13H5V11ZM2 2H15V10H2L2 2ZM6 11V13H8V11H6ZM9 11V13H11V11H9Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

DesktopXXLBreakpointIcon.tags = [
  'monitor',
  'tv',
  'computer',
  'display',
  'device',
];

DesktopXXLBreakpointIcon.category = 'General Icons';

DesktopXXLBreakpointIcon.iconSize = 16;
